import type { RootState } from 'tradera/state/configure-store';

export const selectTraderaShop = (state: RootState) => state.views.traderaShop;

export const selectTranslatedDescriptionState = (state: RootState) =>
    selectTraderaShop(state).translatedDescriptionState;

export const selectTranslatedDescription = (state: RootState) =>
    selectTraderaShop(state).translatedDescription || null;

export const selectCurrentDescriptionLanguageCodeIso2 = (state: RootState) =>
    selectTraderaShop(state).currentDescriptionLanguageCodeIso2 || null;
